import { saveAs } from "file-saver";
import { useState } from "react";
import * as XLSX from "xlsx";
import { OrderModel } from "../../data/models/order/OrderModel";
import {
  PAYMENT_METHOD_LABELS,
  TypePaymentMethodEnum,
} from "../../data/models/order/PaymentModel";

export function useExportSales(orders: OrderModel[]) {
  const [from, setFrom] = useState<string>("");
  const [to, setTo] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const exportExcel = () => {
    if (!orders || orders.length === 0) {
      alert("No hay órdenes para exportar");
      return;
    }
    const sortedOrders = [...orders].sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );

    const rows = sortedOrders.map((o) => ({
      Numero: o.fiscalNumber ?? o.id.slice(0, 8),
      Fecha: new Date(o.createdAt),
      Pago: o.paymentMethod
        ? PAYMENT_METHOD_LABELS[o.paymentMethod as TypePaymentMethodEnum]
        : "",
      Subtotal: o.subtotal,
      Descuentos: o.discountValue,
      Total: o.total,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Ventas");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const filename = `ventas_${new Date().toISOString().slice(0, 10)}.xlsx`;

    saveAs(blob, filename);
  };

  return {
    from,
    to,
    setFrom,
    setTo,
    exportExcel,
    loading,
  };
}
